import FsLightbox from "fslightbox";

/* -------------------------------------------------------------------------- */
/*                             Mobile Menu Script                             */
/* -------------------------------------------------------------------------- */
document.addEventListener("DOMContentLoaded", () => {
  var hamBurger = document.getElementById("mobileToggle");
  var menu = document.getElementById("siteMenu");
  var ulElement = document.querySelector(".navigation__links ul");

  hamBurger?.addEventListener("click", () => {
    if (hamBurger?.classList.contains("is-active")) {
      menu?.classList.remove("active");
      hamBurger?.classList.remove("is-active");
      ulElement?.classList.remove("active");
    } else {
      menu?.classList.add("active");
      hamBurger?.classList.add("is-active");
      ulElement?.classList.add("active");
    }
  });

  if (window.innerWidth < 992) {
    ulElement.setAttribute("data-tor-parent", "active");
  } else {
    ulElement.removeAttribute("data-tor-parent");
  }
});

document.addEventListener("DOMContentLoaded", function () {
  refreshFsLightbox();
});

/* -------------------------------------------------------------------------- */
/*                                Submenu tweak                               */
/* -------------------------------------------------------------------------- */

document.addEventListener("DOMContentLoaded", function (event) {
  var parents = document.getElementsByClassName(
    "main-menu__item--parent  main-menu__sub-menu__item"
  );

  for (var i = 0; i < parents.length; i++) {
    var submenu = parents[i].querySelector(".main-menu__sub-menu");
    parents[i].addEventListener("mouseenter", function () {
      submenu.classList.add("active");
    });
    parents[i].addEventListener("mouseleave", function () {
      submenu.classList.remove("active");
    });
  }
});

/* -------------------------------------------------------------------------- */
/*                             Remove phone number                            */
/* -------------------------------------------------------------------------- */
function handleContactText() {
  const contactElement = document.querySelector(
    ".navigation__topbar--contact"
  ) as HTMLElement | null;
  if (!contactElement) return;
  if (contactElement.dataset.originalText === undefined) {
    contactElement.dataset.originalText = contactElement.textContent || "";
  }
  if (window.innerWidth < 576) {
    contactElement.textContent = "";
  } else {
    contactElement.textContent = contactElement.dataset.originalText || "";
  }
}

document.addEventListener("DOMContentLoaded", handleContactText);
window.addEventListener("resize", handleContactText);
